export default __webpack_public_path__ + "static/illustration-content-logo.url-f870f5a6752bd29cbb9078ed34501da5.svg";